module.exports = __webpack_public_path__ + "img/firstImage.b5699499.png";